
import {of as observableOf,  Observable } from 'rxjs';

import { catchError, finalize, tap, map} from 'rxjs/operators';
import { Injectable, Inject, forwardRef } from '@angular/core';
import { Router } from '@angular/router';

import { DateTime } from 'typescript-dotnet-es6/System/Time/DateTime';
import { Http, Response, Headers } from '@angular/http';

import { LoginService } from './login.service';
import { UserProfileModel } from './models/user-profile-model';


@Injectable()
export class UserProfileService {
  isLoggedIn: boolean = false;
  isCustomerIDSet: boolean = false;
  refreshStateFromServer: DateTime = DateTime.now;
  public data: UserProfileModel = new UserProfileModel;


  public loginService: LoginService;
  constructor(
    private http: Http
    , private router: Router
  ) {
    let x = this.http === http;
    this.refreshStateFromServer = DateTime.now;

  }

  CheckAndHandleSessionTimeout() {
    this.IsUserLoggedIn()
      .subscribe(loggedIn => {
        if (!loggedIn) {
          this.router.navigate(['/login'], { queryParams: { redirectTo: this.router.url } });
        }
      },
      (err) => { console.log(err); }
      );
  }
  IsUserLoggedIn(): Observable<boolean> {
    if (this.refreshStateFromServer.toJsDate() > DateTime.now.toJsDate()) {
      return observableOf(this.isLoggedIn && this.isCustomerIDSet);
    }
    else {
      return this.UpdateUserState();
    }
  }
  public SecurityGetUser() {
    let buildList=[];
    return this.loginService.SecurityGetUser().pipe(
      map(r => {
        let cstList: string = r.Customers; /*NSF 2021-04-19 remove SecurityGetUserResult.*/
        let tmpArray = cstList.split('|');
        buildList = tmpArray.map(e => {
          let pair = e.split(':');
          return { text: pair[1], value: Number.parseInt(pair[0]) }
        });
        this.data.allowedCustomerList = buildList;
        return this.data.allowedCustomerList;
      }))
  }

  public GetMappedCustomer(customerName: string) {
    let found = this.data.allowedCustomerList.find((q, r, s) => q.text === customerName);
    return found;
  }
  public GetMappedCustomerById(customerID: number) {
    let found = this.data.allowedCustomerList.find((q, r, s) => q.value === customerID);
    return found;
  }
  public TakeUserToLogoutPage(){
    this.loginService.logout().subscribe(data=>{},err=>console.log(err));
    let logoutUrl = this.data.SSOPortalURL;
    if(logoutUrl){
      window.location.assign(logoutUrl);
    }else{
      this.router.navigate(['/login']);
    }
  }

  public ProcessRiaWcfServiceErrorResponse(err:any){
    console.log(err);
    if(err.status == 500 &&  err._body){
      //This is to handle this type of error response from WCF RIA service HTTP status code 500 with body
      //"{"ErrorCode":401,"ErrorMessage":"Access to operation 'GetAuditStd_JobMonitor' was denied.","IsDomainException":false,"StackTrace":"..."}"
      let body = JSON.parse( err._body);
      if(body.ErrorCode == 401){
        this.TakeUserToLogoutPage();
      }
    }
    else if(err.status==403 || err.status==401){
      this.TakeUserToLogoutPage();
    }
  }

  public ProcessWebApiServiceErrorResponse(err:any){
    console.log(err);
    if(err.status==403 || err.status==401 || err.status==400){
      this.TakeUserToLogoutPage();
    }
  }
  UpdateUserState(): Observable<boolean> {
    return this.loginService
      .userInfo().pipe(
      tap((data) => {
        this.SetState((data !== null) && (!!data.UserName), data.CustomerID !== null);
        this.data.DisplayName = data.DisplayName;
        this.data.UserName = data.UserName;
        this.data.CustomerName = data.CustomerName;
        this.data.RoleList = data.Roles;
        this.data.ProductAccess = data.ProductAccess;
        this.data.SSOPortalAppId = data.SSOPortalAppId;
        this.data.SSOPortalURL = data.SSOPortalURL;
        this.data.CustomerType = data.CustomerType;
        this.data.Email = data.Email;
        this.SecurityGetUser().subscribe();
      },
      err => {
        this.ClearUserInfo();
      }),
      map(() => this.isLoggedIn && this.isCustomerIDSet),
      finalize(() => { console.log("UpdateUserState out"); }),
      catchError((err, caught)=>{
        if(err.status == 401 || err.status == 403){
          this.ClearUserInfo();
          return observableOf(false);
        }
        return observableOf(true);
      }));
  }
  public ClearUserInfo(){
    this.SetState(false, false);
    this.data.DisplayName = "";
    this.data.CustomerName = "";
    this.data.RoleList = [];
    this.data.ProductAccess = [];
    this.data.SSOPortalAppId = "";
    this.data.SSOPortalURL = "";
    this.data.CustomerType = "";
    this.data.Email = "";

  }
  SetState(s: boolean, cidSet: boolean) {
    this.refreshStateFromServer = DateTime.now.addMinutes(5);
    this.isLoggedIn = s;
    this.isCustomerIDSet = cidSet;
  }

}
